// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Photos__row":"tl_a bii_a bii_r bii_j","Photos__img":"tl_b bii_b"};